import chroma from 'chroma-js';
import { zipObject } from 'lodash-es';

/**
 * Collection of design tokens for colors, each generated as a swatch ranging from tints (lighter)
 * to shades (darker).
 */ const colors = {
    gray: colorSwatch('#576377'),
    blue: colorSwatch('#167dfd'),
    indigo: colorSwatch('#4f6ef4'),
    violet: colorSwatch('#875df6'),
    purple: colorSwatch('#ab54f6'),
    fuchsia: colorSwatch('#d946ef'),
    pink: colorSwatch('#e93790'),
    red: colorSwatch('#ee3c46'),
    orange: colorSwatch('#ff5c0b'),
    amber: colorSwatch('#ff8903'),
    yellow: colorSwatch('#f3b40b'),
    lime: colorSwatch('#86cb17'),
    green: colorSwatch('#1dc672'),
    teal: colorSwatch('#06c2a5'),
    cyan: colorSwatch('#03cccf')
};
/**
 * Generates a color swatch for a given color, encompassing tints and shades. Tonal values range
 * from 50 (tints) to 1000 (shades).
 *
 * @param color - Base color for generating the swatch.
 */ function colorSwatch(color) {
    const tintTones = [
        50,
        100,
        200,
        300,
        400
    ];
    const shadeTones = [
        600,
        700,
        800,
        900,
        950
    ];
    const tones = [
        ...tintTones,
        500,
        ...shadeTones
    ];
    const tints = chroma.scale([
        'white',
        color
    ]).gamma(1.8).padding([
        0.06,
        0.25
    ]).colors(tintTones.length).map((tint)=>adjustVibrancy(chroma(tint)).hex());
    const shades = chroma.scale([
        color,
        'black'
    ]).gamma(1.2).padding([
        0.18,
        0.2
    ]).colors(shadeTones.length);
    const colors = [
        ...tints,
        color,
        ...shades
    ];
    return zipObject(tones, colors);
}
/**
 * Adjusts the vibrancy of a color, based on its luminance. Much vibrant.
 *
 * @param color - The color to adjust the vibrancy of.
 */ function adjustVibrancy(color) {
    const adjustmentFactor = 0.5 * (1 - Math.abs(color.luminance() - 0.5) * 2);
    return color.saturate(adjustmentFactor);
}

export { colors };
//# sourceMappingURL=colors.js.map
